import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 add_product_unit_measurement_details: { status: "idle" },
};

export const add_product_unit_measurement_details_Slice = createSlice({
 name: "add_product_unit_measurement_details",
 initialState,
 reducers: {
  success_add_product_unit_measurement_details: (state, action) => {
   state.add_product_unit_measurement_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_product_unit_measurement_details: (state, action) => {
   state.add_product_unit_measurement_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_product_unit_measurement_details: (state) => {
   state.add_product_unit_measurement_details = { status: app_consts.IDLE };
  },
  loading_add_product_unit_measurement_details: (state) => {
   state.add_product_unit_measurement_details = { status: app_consts.LOADING };
  },
 },
});

export const { success_add_product_unit_measurement_details, fail_add_product_unit_measurement_details, reset_add_product_unit_measurement_details, loading_add_product_unit_measurement_details } =
 add_product_unit_measurement_details_Slice.actions;

export default add_product_unit_measurement_details_Slice.reducer;
